import {
    useSyncExternalStore
} from "react";
import type {
    LabelTextRegisterConstantType,
    LabelTextEntry
} from "./type";

const LABEL_TEXTS = new Map<string, LabelTextEntry>();

const LABEL_TEXT_LISTENERS = new Set<() => void>();

const notifyLabelTextListeners = () => {
    LABEL_TEXT_LISTENERS.forEach((listener) => {
        listener();
    });
};

export const registerLabelText = ({
    htmlFor,
    text
}: LabelTextRegisterConstantType) => {
    const entry: LabelTextEntry = {
        text
    };

    LABEL_TEXTS.set(htmlFor, entry);

    notifyLabelTextListeners();

    return () => {
        if(LABEL_TEXTS.get(htmlFor) !== entry) {
            return;
        }

        LABEL_TEXTS.delete(htmlFor);

        notifyLabelTextListeners();
    };
};

export const subscribeLabelTexts = (listener: () => void) => {
    LABEL_TEXT_LISTENERS.add(listener);

    return () => {
        LABEL_TEXT_LISTENERS.delete(listener);
    };
};

export const getLabelText = (htmlFor?: string): string | undefined => {
    if(!htmlFor) {
        return undefined;
    }

    return LABEL_TEXTS.get(htmlFor)?.text;
};

export const useLabelText = (htmlFor?: string): string | undefined => {
    const getSnapshot = () => getLabelText(htmlFor);

    return useSyncExternalStore(subscribeLabelTexts, getSnapshot, getSnapshot);
};
